import { Box, Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import MeasureResultField from "./MeasureResultField";

interface Distance {
  id: string;
  label: string;
  value: string;
  accuarcy: string;
}

export default function DistanceContent() {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const showSmallToolContent = sidebarStore(
    (state) => state.showSmallToolContent
  );
  const distanceToolValues = sidebarStore((state) => state.distanceToolValues);
  const distanceActiveAttributes = sidebarStore(
    (state) => state.distanceActiveAttributes
  );
  const changeDistanceActiveAttributes = sidebarStore(
    (state) => state.changeDistanceActiveAttributes
  );
  const distanceTool = sidebarStore((state) => state.distanceTool);

  const { t } = useTranslation();

  const defaultValue = "0.00";

  const [height, setHeight] = useState<string>(defaultValue);
  const [horizontal, setHorizontal] = useState<string>(defaultValue);
  const [inclined, setInclined] = useState<string>(defaultValue);
  const [accuaryHeight, setAccuaryHeight] = useState<string>(defaultValue);
  const [accuaryhorizontal, setAccuaryHorizontal] =
    useState<string>(defaultValue);
  const [accuaryinclined, setAccuaryInclined] = useState<string>(defaultValue);
  const [auxiliaryLinesActive, setAuxiliaryLinesActive] =
    useState<boolean>(false);

  //attributes list
  const attributes: Distance[] = [
    {
      id: "slope_distance",
      label: t("distance.inclined"),
      value: inclined,
      accuarcy: accuaryinclined,
    },
    {
      id: "horizontal_distance",
      label: t("distance.horizontal"),
      value: horizontal,
      accuarcy: accuaryhorizontal,
    },
    {
      id: "height_difference",
      label: t("distance.height_difference"),
      value: height,
      accuarcy: accuaryHeight,
    },
  ];

  // //update states for height, horizontal and inclined values
  useEffect(() => {
    if (distanceToolValues !== undefined) {
      setHeight(distanceToolValues.height.toFixed(2));
      setHorizontal(distanceToolValues.distance2d.toFixed(2));
      setInclined(distanceToolValues.distance.toFixed(2));
      setAccuaryHeight(distanceToolValues.precHeight.toFixed(2));
      setAccuaryHorizontal(distanceToolValues.precDistance2d.toFixed(2));
      setAccuaryInclined(distanceToolValues.precDistance.toFixed(2));
    } else {
      setHeight(defaultValue);
      setHorizontal(defaultValue);
      setInclined(defaultValue);
      setAccuaryHeight(defaultValue);
      setAccuaryHorizontal(defaultValue);
      setAccuaryInclined(defaultValue);
    }
  }, [distanceToolValues]);

  useEffect(() => {
    // set checkbox state to the state from the SDK distanceTool
    setAuxiliaryLinesActive(distanceTool.auxlineActive);
    return () => {
      setAuxiliaryLinesActive(distanceTool.auxlineActive);
    };
  }, [distanceTool.auxlineActive]);

  return (
    <Box
      width="100%"
      display={"flex"}
      alignItems={"start"}
      flexDirection={"column"}
      gap={0.5}
    >
      {!showSmallToolContent && (
        <FormControlLabel
          label={t("measurement.distance_show_auxiliary_lines")}
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "16px",
              color: darkTheme ? "white" : "darkblue.main",
              userSelect: "none",
            },
          }}
          control={
            <Checkbox
              size="small"
              classes={{
                root: darkTheme
                  ? "editFeatureRadioButtonAccentWhite"
                  : "editFeatureRadioButtonAccent",
                checked: darkTheme
                  ? "editFeatureRadioButtonAccentWhite"
                  : "editFeatureRadioButtonAccent",
              }}
              checked={auxiliaryLinesActive}
              onChange={() => {
                if (!auxiliaryLinesActive) {
                  distanceTool?.enableAuxline();
                  setAuxiliaryLinesActive(true);
                } else {
                  distanceTool?.disableAuxline();
                  setAuxiliaryLinesActive(false);
                }
              }}
            />
          }
        />
      )}
      {attributes
        .filter((item: Distance) => {
          if (showSmallToolContent) {
            return distanceActiveAttributes.includes(item.id);
          } else {
            return item;
          }
        })
        .map((item: Distance) => (
          <MeasureResultField
            key={item.id}
            id={item.id}
            title={item.label}
            value={item.value + " m"}
            loggingString={`Distance ${item.id.split("_")[0]}`}
            activeAttributes={distanceActiveAttributes}
            changeActiveAttributes={changeDistanceActiveAttributes}
            showPin={attributes.length > 1}
          />
        ))}
    </Box>
  );
}
